class BasketError extends Error {
  code?: number;
  constructor(message: string | number) {
    super(`${message}`);
    Object.setPrototypeOf(this, BasketError.prototype);
  }
}

export class AddToBasketError extends BasketError {
  constructor(message: string | number) {
    super(message);
    this.name = 'AddToBasketError';
    Object.setPrototypeOf(this, AddToBasketError.prototype);
  }
}

export class CaptchaError extends BasketError {
  constructor(message: string) {
    super(message);
    this.name = 'CaptchaError';
    Object.setPrototypeOf(this, CaptchaError.prototype);
  }
}
